<nz-page-header *ngIf="!userIdModal" class="site-page-header">
  <nz-breadcrumb nz-page-header-breadcrumb>
    <nz-breadcrumb-item>
      <a routerLink="../..">
        <i nz-icon nzType="home"></i>
      </a>
    </nz-breadcrumb-item>
    <nz-breadcrumb-item>
      <a routerLink="..">Usuários</a>
    </nz-breadcrumb-item>
    <nz-breadcrumb-item>
      <i nz-icon nzType="user"></i>
      Usuário
    </nz-breadcrumb-item>
  </nz-breadcrumb>
  <nz-page-header-title>Usuários</nz-page-header-title>
</nz-page-header>

<div class="px-4">
  <ng-container *ngIf="route.data | async as data">
    <div nz-row class="space-align-container">
      <div nz-col>
        <nz-avatar [nzSize]="64" nzIcon="user" [nzSrc]="data.user?.picture?.url"></nz-avatar>
      </div>
      <div nz-col nzSpan="18" nz-scape nzAlign="center" class="space-align-block">
        <h2>{{ data.user?.firstName }} {{ data.user?.lastName }}</h2>
      </div>
    </div>
    <hr />
    <div>
      <div nz-row>
        <div nz-col>
          <label>User:</label>
          <span>
            {{ data.user?._id }}
          </span>
        </div>
        <div nz-col style="margin-left: auto" *ngIf="!userIdModal">
          <button nz-button [nzType]="'primary'" (click)="showModalUpdateEmail(data.user)">
            <p>Editar Email</p>
          </button>
          <button style="margin-left: 5px" nz-button [nzType]="'primary'" (click)="showModalResetPassword(data.user)">
            <p>Resetar Senha</p>
          </button>
        </div>
      </div>

      <div>
        <label>Email:</label>
        <span>
          {{ data.user?.email }}
        </span>
      </div>
      <div *ngFor="let doc of data.user?.ids">
        <label>{{ doc?.type }}:</label>
        <span>
          {{ doc?.number }}
        </span>
      </div>
      <div *ngIf="data.user?.phones?.length">
        <label>Telefone:</label>
        <span>
          {{ data.user?.phones }}
        </span>
      </div>
      <div>
        <label>System Admin:</label>
        <span>
          {{ data.user?.isSystemAdmin ? 'Sim' : 'Não' }}
        </span>
      </div>
      <div *ngIf="data.user?.createdBy">
        <label>CreatedBy:</label>
        <button nz-button nzSize="small" [nzType]="'primary'" [routerLink]="['/home/users/', data.user?.createdBy._id]">
          <p>{{ data.user?.createdBy?.fullName }}</p>
        </button>
      </div>
    </div>

    <div *ngIf="data.user?.residencesUser?.length" style="margin: 5px">
      <nz-collapse>
        <nz-collapse-panel [nzHeader]="'Residences User'">
          <nz-collapse>
            <nz-collapse-panel *ngFor="let residence of data.user?.residencesUser; let i = index" [nzHeader]="'Residencia ' + i">
              <div>
                <label>Residence id:</label>
                <span>{{ residence._id }}</span>
              </div>
              <div>
                <label>Condo id:</label>
                <span>{{ residence.condo }}</span>
              </div>
              <div>
                <label>Residence identification:</label>
                <span>{{ residence.identification }}</span>
              </div>
              <div>
                <label>Residence address:</label>
                <span>{{ residence.address }}</span>
              </div>
              <div>
                <label>Residence number:</label>
                <span>{{ residence.number }}</span>
              </div>
              <div>
                <label>Residence block:</label>
                <span>{{ residence.block }}</span>
              </div>
              <div>
                <label>Residence type:</label>
                <span>{{ residence.type }}</span>
              </div>
              <div>
                <label>Residence dependents quantity:</label>
                <span>{{ residence.qtDependents }}</span>
              </div>
            </nz-collapse-panel>
          </nz-collapse>
        </nz-collapse-panel>
      </nz-collapse>
    </div>
    <div *ngIf="data.user?.condos?.length" style="margin: 5px">
      <nz-collapse>
        <nz-collapse-panel [nzHeader]="'Condômino'">
          <nz-collapse>
            <nz-collapse-panel *ngFor="let condo of data.user?.condos" [nzHeader]="condo.name">
              <label>Condo id:</label>
              <span>{{ condo._id }}</span>
            </nz-collapse-panel>
          </nz-collapse>
        </nz-collapse-panel>
      </nz-collapse>
    </div>
    <div *ngIf="data.user?.condosAdmin?.length" style="margin: 5px">
      <nz-collapse>
        <nz-collapse-panel [nzHeader]="'Administrador'">
          <nz-collapse>
            <nz-collapse-panel *ngFor="let condo of data.user?.condosAdmin" [nzHeader]="condo.name">
              <label>Condo id:</label>
              <span>{{ condo._id }}</span>
            </nz-collapse-panel>
          </nz-collapse>
        </nz-collapse-panel>
      </nz-collapse>
    </div>
    <div *ngIf="data.user?.condosOwner?.length" style="margin: 5px">
      <nz-collapse>
        <nz-collapse-panel [nzHeader]="'Síndico'">
          <nz-collapse>
            <nz-collapse-panel *ngFor="let condo of data.user?.condosOwner" [nzHeader]="condo.name">
              <label>Condo id:</label>
              <span>{{ condo._id }}</span>
            </nz-collapse-panel>
          </nz-collapse>
        </nz-collapse-panel>
      </nz-collapse>
    </div>
    <div *ngIf="data.user?.condosGatekeeper?.length" style="margin: 5px">
      <nz-collapse>
        <nz-collapse-panel [nzHeader]="'Porteiro'">
          <nz-collapse>
            <nz-collapse-panel *ngFor="let condo of data.user?.condosGatekeeper" [nzHeader]="condo.name">
              <label>Condo id:</label>
              <span>{{ condo._id }}</span>
            </nz-collapse-panel>
          </nz-collapse>
        </nz-collapse-panel>
      </nz-collapse>
    </div>
    <div *ngIf="data.user?.condosJanitor?.length" style="margin: 5px">
      <nz-collapse>
        <nz-collapse-panel [nzHeader]="'Zelador'">
          <nz-collapse>
            <nz-collapse-panel *ngFor="let condo of data.user?.condosJanitor" [nzHeader]="condo.name">
              <label>Condo id:</label>
              <span>{{ condo._id }}</span>
            </nz-collapse-panel>
          </nz-collapse>
        </nz-collapse-panel>
      </nz-collapse>
    </div>
    <div *ngIf="data.user?.condosRequester?.length" style="margin: 5px">
      <nz-collapse>
        <nz-collapse-panel [nzHeader]="'Condos Requester'">
          <nz-collapse>
            <nz-collapse-panel *ngFor="let condo of data.user?.condosRequester" [nzHeader]="condo.name">
              <label>Condo id:</label>
              <span>{{ condo._id }}</span>
            </nz-collapse-panel>
          </nz-collapse>
        </nz-collapse-panel>
      </nz-collapse>
    </div>
    <div *ngIf="data.user?.condosLawyer?.length" style="margin: 5px">
      <nz-collapse>
        <nz-collapse-panel [nzHeader]="'Advogado'">
          <nz-collapse>
            <nz-collapse-panel *ngFor="let condo of data.user?.condosLawyer" [nzHeader]="condo.name">
              <label>Condo id:</label>
              <span>{{ condo._id }}</span>
            </nz-collapse-panel>
          </nz-collapse>
        </nz-collapse-panel>
      </nz-collapse>
    </div>
  </ng-container>
</div>

<hr />

<div class="px-4">
  <aside class="mt-3 disconnect-all-devices-title">
    <i style="font-size: 2rem" nz-icon nzType="logout" nzTheme="outline"></i>
    <h2>Dispositivos conectados</h2>
  </aside>

  <div class="connected-devices-table mt-2">
    <div class="disconnect-all-devices">
      <h2>Meus dispositivos conectados</h2>
      <button nz-button nzType="default" nzDanger (click)="disconectAllDevices()">
        Desconectar todos os dispositivos
        <i nz-icon nzType="info-circle" nz-tooltip="Remove todas as conexões exceto a atual"></i>
      </button>
    </div>

    <nz-table #devices [nzData]="connectedDevices" [nzFrontPagination]="false">
      <thead>
        <tr>
          <th>Data e hora</th>
          <th>Navegador</th>
          <th>Sistema Operacional</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let device of devices.data">
          <td>{{ device.createdAt ? (device.createdAt | date: 'dd/MM/yyyy - HH:mm') : '-' }}</td>
          <td>{{ device.userInfo?.browser || '-' }}</td>
          <td>{{ device.userInfo?.os || '-' }}</td>
          <td>
            <button nz-button nzType="primary" (click)="disconnectDevice(device._id)">Desconectar dispositivo</button>
          </td>
        </tr>
        <tr class="text-end" *ngIf="connectedDevices.length === 0">
          <td colspan="5" class="text-center">Nenhum dispositivo conectado.</td>
        </tr>
      </tbody>

      <div *ngIf="status === 'ERROR'" class="mt-3 text-center">
        <button nz-button nzType="primary" (click)="getData()">Tentar novamente</button>
      </div>
    </nz-table>

    <nz-pagination
      nz-row
      nzJustify="end"
      nzShowSizeChanger
      [nzTotal]="total"
      [nzPageIndex]="0"
      [nzPageSize]="nzPageSize"
      [nzPageSizeOptions]="[10, 20, 30, 40, 50]"
      (nzPageIndexChange)="refreshIndexChange($event)"
      (nzPageSizeChange)="refreshSizeChange($event)"></nz-pagination>
  </div>
</div>
